<script>
import {HorizontalBar} from 'vue-chartjs';
import {mapState, mapActions} from 'vuex';

export default {
    extends: HorizontalBar,
    props: {
        chartData: {
            type: Array,
            required: true
        },
        labels: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        filteredSites: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            baseColor: '#64C1C7',
            activeColor: '#F4A830',
            selectedIndex: 0,
        }
    },
    computed: {
        ...mapState({
            sites: state => state.stats.sites.value,
            loading: state => state.stats.sites.loading,
            error: state => state.stats.sites.error,
            noContent: state => state.stats.sites.noContent,
            selectedSite: state => state.stats.selectedSite
        }),
        backgroundColors () {
            let colors = [];
            for (let i = 0; i < this.filteredSites.length; i++) {
                if (this.selectedSite.id === this.filteredSites[i].id) {
                    colors.push(this.activeColor);
                } else {
                    colors.push(this.baseColor);
                }
            }
            return colors;
        },
        coloredDatasets () {
            let datasets = this.chartData.slice();
            datasets[0].backgroundColor = this.backgroundColors;
            return datasets;
        },
    },
    watch: {
        chartData: {
            deep: true,
            handler () {
                this.$data._chart.destroy();
                this.rerenderChart();
            }
        },
    },
    mounted () {
        this.rerenderChart();
    },
    methods: {
        ...mapActions({
            updateSelectedSite: 'stats/updateSelectedSite'
        }),
        rerenderChart () {
            this.updateSelectedSite(this.filteredSites[0]).then(() => {
                this.renderChart({
                    labels: this.labels,
                    datasets: this.coloredDatasets
                }, {
                    ...this.options,
                    onClick: this.setActiveBar,
                    onHover: this.showCursor
                });
            });
        },
        setActiveBar (event, elements) {
            let dataset;

            if (elements.length) {
                let index = elements[0]._index;
                this.updateSelectedSite(this.filteredSites[index]).then(() => {
                    this.selectedIndex = index;
                    dataset = this.$data._chart.data.datasets[0];
                    dataset.backgroundColor = this.backgroundColors.slice();
                    this.$data._chart.update();
                });
            }

        },
        showCursor (event, elements) {
            if (elements.length) {
                event.target.style.cursor = 'pointer'
            } else {
                event.target.style.cursor = 'default'
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/StatSitesGraph/StatSitesGraph.vue